<template>
    <div class="header-view">
        <div v-if="options.length > 0"
            class="header-option"
        >
            <i class="align-middle fas fa-fw fa-ellipsis-v" 
                @click="toggle"
            ></i>
        </div>
        <ul class="btn-group-row option-group"
            :class="{'show':isShow}"
        >
            <li v-for="option in options" :key="option.title">
                <router-link v-if="option.to" :to="option.to">
                    <button class="btn btn-pill" :class="option.btnColor">
                        <i :class="option.icon"></i><span>{{ option.title }}</span>
                    </button>
                </router-link>
                <button v-else @click="option.clickHandle" class="btn btn-pill" :class="option.btnColor">
                    <i :class="option.icon"></i><span>{{ option.title }}</span>
                </button>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name:'heardOptionView',
    props:{
        options: {
            type: Array,
            default: [{}]
        },
    },
    data(){
        return {
            isShow:false
        }
    },
    components: {
        
    },
    methods:{
        toggle(){
            event.stopPropagation();
            this.isShow = !this.isShow;
        },
        handleOutsideClick(event) {
            // 判斷螢幕寬度是否小於等於 1200px
            if (window.innerWidth <= 1200) {
                const dropdown = this.$el.querySelector('.btn-group-row.option-group.show');
                // 如果點擊的目標不在選單內，則關閉選單
                if (dropdown && !dropdown.contains(event.target)) {
                    this.isShow = false;
                }
            }
        },
        /**
         * 全域快捷鍵監聽，處理 Ctrl+S / Cmd+S 自動對應儲存按鈕
         * @param {KeyboardEvent} e - 鍵盤事件物件
         */
        handleKeyDown(e) {
            if ((e.ctrlKey || e.metaKey) && (e.key === 's' || e.key === 'S')) {
                // 尋找出標題或圖示符合儲存/更新的選項
                const saveOption = this.options.find(opt => 
                    opt.isSave || 
                    (opt.icon && opt.icon.includes('fa-save')) || 
                    (opt.title && (opt.title.includes('儲存') || opt.title.includes('更新')))
                );
                
                if (saveOption && typeof saveOption.clickHandle === 'function') {
                    e.preventDefault();
                    saveOption.clickHandle();
                }
            }
        },
    },
    async mounted(){
        // 在全域範圍內監聽點擊事件
        document.addEventListener('click', this.handleOutsideClick);
        window.addEventListener('keydown', this.handleKeyDown);
    },
    beforeUnmount() {
        // 移除全域的點擊監聽器與鍵盤監聽，避免記憶體洩漏
        document.removeEventListener('click', this.handleOutsideClick);
        window.removeEventListener('keydown', this.handleKeyDown);
    },
    async created(){
        
    }
  };
  </script>
<style scoped>
.mobile-show{
    display: none;
}

.header-view > .header-option{
    display: none;
}

@media (max-width: 1200px) {
    .header-view{
        position: relative;
    }
    .header-view > .header-option{
        display: block;
    }
    .header-view > .option-group{
        display: none;
        position: absolute;
        transform: translateX(-100%);
        z-index: 1020;
        background-color: #ffffff;
        box-shadow: 2px 2px 8px #00000047;
        padding: .5rem;
        border-radius: 4px;
    }
    .header-view > .option-group.show{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
}
@media (max-width: 767px) {
    .header-view > .header-option{
        display: block;
    }
    .mobile-show{
        display: flex;
    }
    ul.option-group > li {
        width: 100%;
    }
    ul.option-group > li > button, ul.option-group > li > a > button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        /* transition: all 0.3s ease; */
        /* overflow: hidden; */
        position: relative;
        white-space: nowrap;
        text-decoration: none !important;
    }
    ul.option-group > li > button span, ul.option-group > li > a > button span {
        display: block;
        white-space: nowrap;
        margin-left: .5rem;
        text-decoration: none !important;
    }
    ul.option-group > li > button:hover span , ul.option-group > li > a > button:hover span {
        position: static; /* 重設為預設定位方式 */
        z-index: auto;    /* 移除 z-index 屬性 */
        top: auto;
        left: auto;
        transform: none;
        border-radius: 0;
        color: inherit;   /* 恢復原本的文字顏色 */
        padding: 0;
        background-color: transparent;
        box-shadow: none;
    }
}
</style>